import {UnavailableService} from '../services';
import {bindLoading} from './index';


export default {
    namespaced: true,
    state: {
        unavailables: [],
        vacancies: [],
    },

    mutations: {
        saveUnavailables(current, unavailables) {
            current.unavailables.splice(0);
            current.unavailables = [...unavailables];
        },
        saveVacancies(current, vacancies){
            current.vacancies.splice(0);
            current.vacancies = [...vacancies];
        }
    },
    actions: {
        async getUnavailablesAction({commit}, filter) {
            await bindLoading(commit, async () => commit('saveUnavailables'
                , await UnavailableService.getUnavailables(filter)), 'unavailable')
        },

        async deleteUnavailableAction({commit, state}, id) {
            return await bindLoading(commit, async () => {

                const result = await UnavailableService.deleteUnavailable(id);

                if (result.success) {
                    const unavailables = [...state.unavailables.filter(r => r.id !== id)];
                    commit('saveUnavailables', unavailables);
                }
                return result;
            }, 'unavailable');

        },

        async deleteUnavailableRangeAction({commit, state}, ids = []) {
            return await bindLoading(commit, async () => {

                const result = await UnavailableService.deleteUnavailableRange({ids});

                if (result.success) {
                    const unavailables = [...state.unavailables.filter(r => !ids.some(i => r.id === i))];
                    commit('saveUnavailables', unavailables);
                }
                return result;
            }, 'unavailable');

        },

        async getVacancyRoomsInRangeAction({commit}, filter) {
            await bindLoading(commit, async () => commit('saveVacancies'
                , await UnavailableService.getVacancyRoomsInRange(filter)), 'unavailable')
        },

        async getVacancyRoomsInRangeExceptAction({commit}, filter) {
            await bindLoading(commit, async () => commit('saveVacancies'
                , await UnavailableService.getVacancyRoomsInRangeExceptOf(filter)), 'unavailable')
        },

        async insertUnavailableRangeAction({commit, dispatch}, unavailables = []) {
            return await bindLoading(commit, async () => {

                const result = await UnavailableService.insertUnavailableRange(unavailables);

                if (result.success) {
                    await dispatch('getUnavailablesAction', {
                        all: true,
                        conditions: {
                            'schoolYear': unavailables[0].schoolYear,
                            'semester': unavailables[0].semester
                        },
                    });
                }
                return result;
            }, 'unavailable');

        },

        async updateUnavailableAction({commit, state}, unavailable) {
            return await bindLoading(commit, async () => {

                const result = await UnavailableService.updateUnavailableRange(unavailable);
                if (result.success) {
                    const unavailables = [...state.unavailables.filter(r => r.id !== unavailable.id), unavailable];
                    commit('saveUnavailables', unavailables);
                }
                return result;
            }, 'unavailable');

        },
    }
}